import React, { useState } from 'react';
import { Button } from '@ipc/ipc-components';

import { redButton } from '../../../styles/themes';
import { ComponentWrapper, TableWrapper, TableBackground } from './styles';
import AlaDiagram from '../../../images/ALA_Diagram.png';

const AlaTableView = () => {
  const [showTable, updateShowTable] = useState(false);
  const toggleShowTable = () => updateShowTable(!showTable);
  const hideTable = () => updateShowTable(false);

  return (
    <ComponentWrapper>
      <Button theme={redButton} onClick={toggleShowTable} className="tabbed">View ALAs</Button>

      {
        showTable && (
          <>
            <TableBackground onClick={hideTable} />
            <TableWrapper>
              <img width="1020px" src={AlaDiagram} alt="ALA Diagram" />
            </TableWrapper>
          </>
        )
      }
    </ComponentWrapper>
  );
};

export default AlaTableView;
